import { OrganizationModel } from '../models/organization.model';
import { CollectionModel } from 'src/app/organizations/models/collection.model';
import {
  OrganizationInviteModel,
  OrganizationInviteResponse,
  OrganizationUserRole,
  UserContentTransfer,
} from '../organizations.service';
import { OrganizationUserModel } from '../models/organization-user.model';
import { OrganizationUpdateModel } from '../models/organization-update';
import {
  OrganizationProfileModel,
  OrganizationProfileRequest,
} from '../models/organization-profile.model';
import { HttpErrorResponse } from '@angular/common/http';

export class SetOrganizations {
  static readonly type = '[Organizations] Set Organizations';
  constructor(public organizations: OrganizationModel[]) {}
}

export class SelectOrganization {
  static readonly type = '[Organizations] Select Organization';
  constructor(public organization: OrganizationModel) {}
}

export class SelectCollection {
  static readonly type = '[Organizations] Select Collection';
  constructor(public collection: CollectionModel) {}
}

export class GetCollections {
  static readonly type = '[Organizations] Get Collections';
  constructor(public organizationId: number) {}
}

export class GetCollectionsSuccess {
  static readonly type = '[Organizations] Get Collections Success';
  constructor(public collections: CollectionModel[]) {}
}

export class AddCollection {
  static readonly type = '[Organizations] Add Collection';
  constructor(public organizationId: number, public collectionName: string) {}
}

export class AddCollectionSuccess {
  static readonly type = '[Organizations] Add Collection Success';
  constructor(public organizationId: number, public collectionName: string) {}
}

export class AddCollectionError {
  static readonly type = '[Organizations] Add Collection Error';
  constructor(public error: HttpErrorResponse) {}
}

export class RemoveCollection {
  static readonly type = '[Organizations] Remove Collection';
  constructor(public collection: CollectionModel) {}
}

export class RemoveCollectionSuccess {
  static readonly type = '[Organizations] Remove Collection Success';
  constructor(public collection: CollectionModel) {}
}

export class RemoveCollectionError {
  static readonly type = '[Organizations] Remove Collection Error';
  constructor(public error: HttpErrorResponse) {}
}

export class SetCollectionRenaming {
  static readonly type = '[Organizations] Set Collection Rename Mode';
  constructor(public collection: CollectionModel) {}
}

export class RenameCollection {
  static readonly type = '[Organizations] Rename Collection';
  constructor(public collection: CollectionModel, public collectionName: string) {}
}

export class RenameCollectionSuccess {
  static readonly type = '[Organizations] Rename Collection Success';
  constructor(public collection: CollectionModel, public collectionName: string) {}
}

export class RenameCollectionError {
  static readonly type = '[Organizations] Rename Collection Error';
  constructor(public error: HttpErrorResponse) {}
}

export class ReorderCollections {
  static readonly type = '[Organizations] Reorder Collections';
  constructor(public organizationId: number, public collections: CollectionModel[]) {}
}

export class ReorderCollectionsSuccess {
  static readonly type = '[Organizations] Reorder Collections Success';
  constructor(public organizationId: number, public collections: CollectionModel[]) {}
}

export class ReorderCollectionsError {
  static readonly type = '[Organizations] Reorder Collections Error';
  constructor(public error: HttpErrorResponse) {}
}

export class JoinOrganization {
  static readonly type = '[Organizations] Join Organization';
  constructor(public organization: OrganizationModel) {}
}

export class JoinOrganizationSuccess {
  static readonly type = '[Organizations] Join Organization Success';
  constructor(public organization: OrganizationModel) {}
}

export class JoinOrganizationFail {
  static readonly type = '[Organizations] Join Organization Fail';
  constructor(public organization: OrganizationModel) {}
}

export class JoinOrganizationWithCode {
  static readonly type = '[Organizations] Join Organization With Code';
  constructor(public code: string) {}
}

export class JoinOrganizationWithCodeSuccess {
  static readonly type = '[Organizations] Join Organization With Code Success';
  constructor(public organizationName: string) {}
}

export class JoinOrganizationWithCodeFail {
  static readonly type = '[Organizations] Join Organization With Code Fail';
  constructor(public error: Error) {}
}

// Organization Invite
export class SendOrganizationInvite {
  static readonly type = '[Organizations] Send Organization Invite';
  constructor(public groupEID: string, public invites: OrganizationInviteModel[]) {}
}

export class SendOrganizationInviteSuccess {
  static readonly type = '[Organizations] Send Organization Invite Success';
  constructor(public responses: OrganizationInviteResponse[]) {}
}

export class SendOrganizationInviteFail {
  static readonly type = '[Organizations] Send Organization Invite Fail';
  constructor(public error: Error) {}
}

// Get Users
export class GetOrganizationUsers {
  static readonly type = '[Organizations] Get Organization Users';
  constructor(public groupId: number) {}
}

export class GetOrganizationUsersSuccess {
  static readonly type = '[Organizations] Get Organization Users Success';
  constructor(public users: OrganizationUserModel[]) {}
}

export class GetOrganizationUsersFail {
  static readonly type = '[Organizations] Get Organization Users Fail';
  constructor(public error: Error) {}
}

export class ResetOrganizations {
  static readonly type = '[Organizations] Reset';
  constructor() {}
}

export class UpdateUserRoles {
  static readonly type = '[Organizations] Update User Roles';
  constructor(public groupId: number, public users: OrganizationUserRole[]) {}
}

export class UpdateUserRolesSuccess {
  static readonly type = '[Organizations] Update User Roles Success';
  constructor(public groupId: number, public users: OrganizationUserRole[]) {}
}

export class UpdateUserRolesFail {
  static readonly type = '[Organizations] Update User Roles Fail';
  constructor() {}
}

export class RemoveOrganizationUser {
  static readonly type = '[Organizations] Remove Organization User';
  constructor(public groupId: number, public users: UserContentTransfer[]) {}
}

export class RemoveOrganizationUserSuccess {
  static readonly type = '[Organizations] Remove Organization User Success';
  constructor(public groupId: number, public users: UserContentTransfer[]) {}
}

export class RemoveOrganizationUserFail {
  static readonly type = '[Organizations] Remove Organization User Fail';
  constructor() {}
}

export class TransferOrganizationContent {
  static readonly type = '[Organizations] Transfer Organization Content';
  constructor(public groupId: number, public users: UserContentTransfer[]) {}
}

export class TransferOrganizationContentSuccess {
  static readonly type = '[Organizations] Transfer Organization Content Success';
  constructor(public groupId: number, public users: UserContentTransfer[]) {}
}

export class TransferOrganizationContentFail {
  static readonly type = '[Organizations] Transfer Organization Content Fail';
  constructor() {}
}

// team creation
export class CreateOrganization {
  static readonly type = '[Organizations] Create Organization';
  constructor(public organization: OrganizationUpdateModel) {}
}

export class CreateOrganizationSuccess {
  static readonly type = '[Organizations] Create Organization Success';
  constructor() {}
}

export class CreateOrganizationFail {
  static readonly type = '[Organizations] Create Organization Fail';
  constructor(public error: Error) {}
}

// team update
export class UpdateOrganization {
  static readonly type = '[Organizations] Update Organization';
  constructor(public organization: OrganizationUpdateModel) {}
}

export class UpdateOrganizationSuccess {
  static readonly type = '[Organizations] Update Organization Success';
  constructor() {}
}

export class UpdateOrganizationFail {
  static readonly type = '[Organizations] Update Organization Fail';
  constructor(public error: Error) {}
}

// team: public profile
export class GetOrganizationProfile {
  static readonly type = '[Organizations] Get Organization Profile';
  constructor(public request: OrganizationProfileRequest) {}
}

export class GetOrganizationProfileSuccess {
  static readonly type = '[Organizations] Get Organization Profile Success';
  constructor(public organizationProfile: OrganizationProfileModel) {}
}

export class GetOrganizationProfileFail {
  static readonly type = '[Organizations] Get Organization Profile Fail';
  constructor(public error: HttpErrorResponse) {}
}

export class ClearOrganizationProfile {
  static readonly type = '[Organizations] Clear Organization Profile';
  constructor() {}
}
